import { zendeskUrl } from "~/utils/zendesk";

export const ZENDESK_HELP_URL = zendeskUrl("43511727336461-Getting-Started-with-AI");
export const ZENDESK_SKILLS_URL = zendeskUrl("43648526871437-AI-Skills-Guide");
